<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Packages ({{ packages.length || 0 }})</h5>
              <button
                type="button"
                class="btn btn-outline-primary"
                @click="onClickAddNewBanner"
              >
                +
              </button>
            </div>

            <div class="empty" v-if="packages.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped custom-table" v-else>
              <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Category</th>
                  <th scope="col">Price</th>
                  <th style="width: 12rem" scope="col">Cover Image</th>
                  <th style="width: 40%" scope="col">Tests</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="item.id" v-for="item in packages">
                  <th scope="row">{{ item.id }}</th>
                  <td>{{ item.name || "--" }}</td>
                  <td>{{ item.category || "--" }}</td>
                  <td>{{ item.price || "--" }}</td>
                  <td>
                    <img class="preview" :src="item.cover_url" alt="" />
                  </td>
                  <td>
                    <ul class="tests">
                      <li
                        class="test"
                        v-bind:key="test"
                        v-for="test in JSON.parse(JSON.stringify(item.tests))"
                      >
                        {{ test }}
                      </li>
                    </ul>
                  </td>

                  <td style="display: grid; gap: 10px">
                    <button
                      type="button"
                      class="btn btn-outline-warning"
                      @click="onClickEditPackage(item)"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-danger"
                      @click="onClickDeletePackage(item)"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <create-package-component
        v-if="showPackageCreationComponent"
        :editModel="editablePackage"
        @success="packageCreationSuccess"
        @cancel="packageCreationCancelled"
      ></create-package-component>

      <delete-item-modal
        :schemtics="packageDeleteSchemetics"
        v-if="showDeletePackageModal"
        @success="onPackageDeleteSuccess"
        @cancel="onPackageDeleteCancelled"
      ></delete-item-modal>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
var NotificationsController = require("../components/NotificationsController.js");
import CreatePackageComponent from "../components/CreatePackageComponent.vue";
import DeleteItemModal from "../components/DeleteItemModal.vue";

import moment from "moment";
export default {
  name: "Packages",
  components: {
    NavBar,
    CreatePackageComponent,
    DeleteItemModal,
  },
  data() {
    return {
      packages: [],
      showPackageCreationComponent: false,
      packageDeleteSchemetics: {},
      showDeletePackageModal: false,
      editablePackage: null,
    };
  },
  methods: {
    onClickEditPackage(item) {
      this.editablePackage = item;
      this.showPackageCreationComponent = true;
    },
    onPackageDeleteCancelled() {
      this.showDeletePackageModal = false;
      this.packageDeleteSchemetics = {};
    },
    onPackageDeleteSuccess() {
      this.showDeletePackageModal = false;
      this.packageDeleteSchemetics = {};
      this.getPackages();
    },
    onClickDeletePackage(item) {
      let access_level = localStorage.getItem("access_level");
      if (access_level != 1) {
        this.$toast.error(
          "Only banner with access level 1 can delete other packages"
        );
        return;
      }
      let url = URLS.PACKAGE.BY_ID.replace(":id", item.id);
      this.packageDeleteSchemetics = {
        endpoint: url,
        title: "Delete Package",
        description: `Are you sure you want to delete <b> ${item.name} </b> from the packages list ?`,
      };
      this.showDeletePackageModal = true;
    },
    onClickAddNewBanner() {
      this.showPackageCreationComponent = true;
      this.editablePackage = null;
    },
    packageCreationSuccess(res) {
      this.showPackageCreationComponent = false;
      this.editablePackage = null;
      this.getPackages();
    },
    packageCreationCancelled() {
      this.showPackageCreationComponent = false;
      this.editablePackage = null;
    },
    getPackages() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.PACKAGE.LIST;
      HTTP.get(url)
        .then((response) => {
          let rows = response.data;
          ctx.packages = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getPackages();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.preview {
  width: 8rem;
  height: 4.5rem;
}

.tests {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    align-items: center;

    .pager {
      margin-left: auto;
      margin-right: 1rem;
    }

    button {
      height: 3rem;
      font-size: 2rem;
      text-align: center;
      line-height: 1rem;
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.filters-container {
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;
  width: 100%;

  .input-group {
    display: flex;
    align-items: center;

    div {
      height: 100% !important;
    }

    input {
      height: 100% !important;
    }
  }

  .actions {
    margin-left: auto;
    width: 200px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    button {
      widows: 100px;
    }
  }
  // button{
  //   margin-left: 10px;
  // }
}
.actions {
  button {
    margin-right: 4px;
  }
}
</style>
